import { render, staticRenderFns } from "./pc-side-menu.vue?vue&type=template&id=383e0838&scoped=true&"
import script from "./pc-side-menu.vue?vue&type=script&lang=js&"
export * from "./pc-side-menu.vue?vue&type=script&lang=js&"
import style0 from "./pc-side-menu.vue?vue&type=style&index=0&id=383e0838&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "383e0838",
  null
  
)

export default component.exports